import { Component } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { NgProgress } from '@ngx-progressbar/core';
import { map } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AppState } from '../../services/app.service';
import { UserService } from '../../dataServices/userService';
import { PdfReportService } from "../../services/pdfReport.service";
import { User } from '../../models/user';

@Component({
    selector: 'self-ins-coverage-proposal',
    templateUrl: './coverage-proposal-page.component.html',
    styleUrls: ['./coverage-proposal-page.component.scss']
})

export class CoverageProposalPageComponent {
    public headerText: string;
    public user: User = this.appState.user.getValue();
    public pdfContent: Uint8Array | null = null;
    public qnum = 0;
    public qsuffix = '';
    
    constructor(private appState: AppState,
                private activeRouter: ActivatedRoute,
                private router: Router,
                private userStatusService: UserService,
                private pdfReportService: PdfReportService,
                private progressBar: NgProgress,) {
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];
        });
        this.headerText = this.user?.status === 'active' ? 'Insurance Summary' :
            'Great Job! We are pleased to present you the opportunity to opt into the Amazon Asset Insurance Program for Amazon Branded units.';
        this.progressBar.ref().start();
        this.pdfReportService.getProposalPdf(this.qnum, this.qsuffix)
            .pipe(
            map((r) => r.content),
            finalize(() => this.progressBar.ref().complete())
        )
            .subscribe((content) => {
            this.pdfContent = new Uint8Array(content as ArrayBuffer);
        });
    }

    public enroll() {
        this.userStatusService.enroll().subscribe(() => {
            this.appState.updateUser({
                ...this.appState.user.getValue(),
                status: 'active'
            });
            this.router.navigate(['/enrollment-confirmation']);
        })
    }
}
